import type { ErrorKind } from '@core/utils/error-handling/classify-error'
import { isDevDeploy } from '@core/utils/error-handling/is-dev-deploy'
import type { TFunction } from 'i18next'

type ErrorTexts = {
  title: string
  description: string
  action: string
}

export function errorTexts(t: TFunction): Record<ErrorKind, ErrorTexts> {
  const unexpected = {
    title: t('designSystem.global.errors.unexpected.title'),
    description: t('designSystem.global.errors.unexpected.description'),
    action: t('designSystem.global.errors.retry'),
  }

  const update = {
    title: t('designSystem.global.errors.update.title'),
    description: t('designSystem.global.errors.update.description'),
    action: t('designSystem.global.errors.update.action'),
  }

  return {
    chunk: isDevDeploy ? update : unexpected,
    network: {
      title: t('designSystem.global.errors.network.title'),
      description: t('designSystem.global.errors.network.description'),
      action: t('designSystem.global.errors.retry'),
    },
    unexpected,
  }
}
